// extracted by mini-css-extract-plugin
export default {"forumLayout":"SQ7wMJW7nKEMvH2Fr68H"};